import { useEffect, useRef, useState } from 'react';

import type { TutorialStepComparison } from '../types';
import * as styles from './tutorial-renderer.css';

export function TutorialComparisonVideo({
  title,
  videoSources,
}: Pick<TutorialStepComparison, 'title' | 'videoSources'>) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [showControls, setShowControls] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    let active = true;
    // Reflect the muted attribute as well as the property for Safari autoplay.
    video.defaultMuted = true;
    video.muted = true;
    void video.play().catch(() => {
      // Browser/user autoplay policies must still leave the clip playable.
      if (active) setShowControls(true);
    });
    return () => {
      active = false;
    };
  }, [videoSources]);

  return (
    <video
      aria-hidden={!showControls}
      aria-label={showControls ? title : undefined}
      autoPlay
      className={styles.comparisonVideo}
      controls={showControls}
      loop
      muted
      playsInline
      preload="auto"
      ref={videoRef}
    >
      {videoSources.map(source => (
        <source key={source.src} src={source.src} type={source.type} />
      ))}
    </video>
  );
}
